import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'

import { apiClient } from '../../../apiClient'
import {
  Batch,
  BatchData,
  BatchParam,
  CompleteBatch,
  GenerateBatch,
  OrderMediaUploadPayload,
  Response,
  SankalpTimeInfo,
  Translate,
  VideoData,
} from './types'

const translateDomain =
  process.env.REACT_APP_ADMIN_BASE_URL || 'https://api-admin.a4b.io'

class BatchApi {
  private api: AxiosInstance

  constructor(config: AxiosRequestConfig) {
    this.api = apiClient.create(config)
  }

  getBatchList = (batchParam: BatchParam) =>
    this.api.get<Response<BatchData>>(
      `/gw1/puja/internal/v1/batches/get-batches`,
      {
        params: batchParam,
      },
    )

  getBatchByCode = (batchCode: string) =>
    this.api.get<Response<Batch>>(`/gw1/puja/internal/v1/batches/${batchCode}`)

  getSankalpTimeInfo = (batchId: string, execution_id?: string) =>
    this.api.get<Response<SankalpTimeInfo[]>>(
      `/gw1/puja/internal/v1/batches/sankalp-info/${batchId}?execution_id=${execution_id}`,
    )

  completeBatch = (batchId: string, payload: CompleteBatch) =>
    this.api.put<Response<any>>(
      `/gw1/puja/internal/v1/batches/${batchId}`,
      payload,
    )

  uploadTagNames = (batchId: string, payload: VideoData) =>
    this.api.post<Response<any>>(
      `gw1/puja/internal/v1/batches/tag-names/${batchId}`,
      payload,
    )

  uploadOrderMedia = (batchId: string, payload: OrderMediaUploadPayload) =>
    this.api.patch<Response<any>>(
      `/gw1/puja/internal/v1/batches/${batchId}`,
      payload,
    )

  translateText = async (batchid: string, nameList: string[]) => {
    const nameListString = encodeURIComponent(JSON.stringify(nameList))
    return await axios.get<Translate>(
      `${translateDomain}/api/translate?batch_id=${batchid}&namelist=${nameListString}`,
    )
  }
  translateToEnglish = async (batchid: string, nameList: string[]) => {
    const nameListString = encodeURIComponent(JSON.stringify(nameList))
    return await axios.get<Translate>(
      `${translateDomain}/api/translateToEnglish?batch_id=${batchid}&namelist=${nameListString}`,
    )
  }
  translateToEnglishPost = async (batchid: string, payload: any) => {
    return await axios.post<Translate>(
      `${translateDomain}/api/translateToEnglish?batch_id=${batchid}`,
      payload,
    )
  }

  listTranslate = async (list: string[], target = 'en', source?: string) => {
    return await axios.get<string[]>(
      `${translateDomain}/api/listTranslate?stringList=${encodeURI(
        JSON.stringify(list),
      )}&target=${target}${source ? '&source=' + source : ''}`,
    )
  }

  translateStringsToHindi = async (strings: string[]) => {
    return await axios.post<{
      data: {
        output: {
          total: number
          strings: string[]
        }
        input: {
          total: number
          strings: string[]
        }
      }
      message: string
    }>(
      `https://xen4v2owityekewgbam5e73lrm0sjoii.lambda-url.ap-south-1.on.aws`,
      {
        target: 'hi',
        strings,
      },
    )
  }

  translatePujaText = async (batchid: string, nameList: string[][]) => {
    const nameListString = encodeURIComponent(JSON.stringify(nameList))
    return await axios.get<string[][]>(
      `${translateDomain}/api/translatePuja?batch_id=${batchid}&namelist=${nameListString}`,
    )
  }
  translatePujaTextToEnglish = async (
    batchid: string,
    nameList: string[][],
  ) => {
    const nameListString = encodeURIComponent(JSON.stringify(nameList))
    return await axios.get<string[][]>(
      `${translateDomain}/api/translatePujaToEnglish?batch_id=${batchid}&namelist=${nameListString}`,
    )
  }
  uploadVideo = (payload: any) =>
    this.api.post<Response<any>>(`/gw1/puja/system/process-video`, payload)

  generateBatches = (payload: any) =>
    this.api.post<Response<GenerateBatch>>(
      `/gw1/puja/internal/v1/batches`,
      payload,
    )

  searchBatches = (payload: string) =>
    this.api.get<Response<Batch>>(`/gw1/puja/internal/v1/batches/${payload}`)

  createDeliveryOrder = (payload: any) =>
    this.api.post(
      '/gw1/puja/internal/v1/batches/create-delivery-order',
      payload,
    )
}

export default BatchApi
